import React, { useEffect, useRef, useState } from "react";
import './Pools.css'
import INCSUBSearchbar from "../../components/common/SearchBar/INCSUBSearchbar";
import INCSUBPoolsSelectStatus from "../../components/Pools/statusSelect";
import INCSUBPoolCard from "../../components/Pools/PoolCard";
import { useDispatch, useSelector } from "react-redux";
import { setPlatformPath, setPoolPath } from "../../redux/commonSlice";
import { getPoolList, getPoolListbyplan } from "../../services/poolServices";
import { toast } from "react-toastify";
import { setPoolList, setSelectedPool } from "../../features/pools/poolsSlice";
import { useNavigate } from "react-router";
import ReactPaginate from "react-paginate";
import INCSUBFilterList from "../../components/common/filter/FilterList";
import INCSUBPoolDetails from "./poolDetails";
import { setPlatformPathRoot } from "../../features/platforms/platformsSlice";


function INCSUBPools() {

    const dispatch = useDispatch();
    const routeStatus = useSelector((state) => state.common.routeStatus);
    const poolList = useSelector((state) => state.pools.poolList);
    const [pageNo, setPageNo] = useState(0);
    const navigate = useNavigate();
    const planInfo = useSelector((state) => state.platforms.planInfo)
    const platformPath = useSelector((state) => state.common.platformPath);
    const [shimmer, setShimmer] = useState(false);
    const shimmerList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
    const [isOpenType, setIsOpenType] = useState(false);
    const poolPath = useSelector((state) => state.common.poolPath);
    const [vacancy, setVacancy] = useState(false);
    const [poolStatus, setPoolStatus] = useState('All');
    const [poolType, setPoolType] = useState('All');
    const [searchKey, setSearchKey] = useState('');
    const [selectedPoolInfo, setSelectedPoolInfo] = useState(null);
    const platformPathRoot = useSelector((state) => state.platforms.platformPathRoot);

    useEffect(() => {
        if (routeStatus === '/pools') {
            window.sessionStorage.setItem('platformPath', '/platformPath')
            dispatch(setPlatformPath('/platforms'))
        }
    }, [])
    const poolTypeList = [{
        id: 'All',
        name: 'All'
    },
    {
        id: 'Standard',
        name: 'Standard'
    },
    {
        id: 'Instant',
        name: 'Instant'
    },
    {
        id: 'Rental',
        name: 'Rental'
    },

    ]
    const poolStatusList = [{
        id: 'All',
        name: 'All'
    },
    {
        id: 'Active',
        name: 'Active'
    },
    {
        id: 'Verification',
        name: 'Verification'
    },
    {
        id: 'Live',
        name: 'Live'
    },
    {
        id: 'Dead',
        name: 'Dead'
    },
    {
        id: 'Suspended',
        name: 'Suspended'
    }]

    const fetchPools = async ({
        searchKeyState = searchKey,
        typeState = poolType,
        statusState = poolStatus,
        vacancyState = vacancy,
        pageNoState = pageNo
    } = {}) => {
        setShimmer(true);
        try {
            let poolsData;

            if (routeStatus === "/pools") {
                poolsData = await getPoolList({ searchKey: searchKeyState, type: typeState, status: statusState, vacancy: vacancyState, pageNo: pageNoState });
            } else if (planInfo) {
                poolsData = await getPoolListbyplan({ planId: planInfo.platformPlanId, searchKey: searchKeyState, type: typeState, status: statusState, vacancy: vacancyState, pageNo: pageNoState });
            }

            if (!poolsData) {
                toast.warning("Something Went Wrong");
            } else if (poolsData.status === 200) {
               
                dispatch(setPoolList(poolsData.data.data));
            } else if (poolsData.status === 400) {
                toast.error(poolsData.data.message);
            } else if (poolsData.status === 401) {
                navigate('/login');
            }
        } catch (err) {
            toast.error("Something went wrong")
        } finally {
            setShimmer(false);
        }
    };

    useEffect(() => {
        // if (poolPath === '/pools') {
            fetchPools();
        // }

    }, [planInfo])

    const handleVacancy = () => {
        setVacancy((prevVacancy) => {
            const newVacancy = !prevVacancy;
            fetchPools({ vacancyState: newVacancy }); // Pass the updated state if needed
            return newVacancy;
        });
    };

    const handleStatusChange = (status) => {
        setPoolStatus((prevStatus) => {
            const newStatus = status.name;
            fetchPools({ statusState: newStatus }); // Pass the updated state if needed
            return newStatus;
        });

    }
    const handleTypeChange = (type) => {
        setPoolType((prevType) => {
            const newType = type.name;
            fetchPools({ typeState: newType }); // Pass the updated state if needed
            return newType;
        });

    }
    const handlePoolSearch = (search) => {
        setSearchKey((prevSearch) => {
            const newSearch = search;
            fetchPools({ searchKeyState: newSearch }); // Pass the updated state if needed
            return newSearch;
        });
    }
    const handlePoolSelect = (pool) => {
        dispatch(setSelectedPool(pool))
        if (routeStatus === '/pools') {
            dispatch(setPoolPath('/pools/poolDetails'));
        }
        if (routeStatus === '/platforms') {
            dispatch(setPlatformPath('/platform/plan/pools/poolsDetails'))
        }
    }
    const renderedPoolsCards = poolList && poolList.poolDetailList && poolList.poolDetailList.length > 0
        ? poolList.poolDetailList.map((pool, index) => {
            return <INCSUBPoolCard key={index} pool={pool} func={handlePoolSelect} />
        })
        : null;

    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = poolList ? poolList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            fetchPools({ pageNoState: event.selected })
            setCurrentPage(event.selected);
            setPageNo(event.selected);
            setItemOffset(event.selected);
        };


        return (

            <>
                {
                    !shimmer && poolList && poolList.poolDetailList.length > 0 && pageCount > 1 ? <ReactPaginate
                        breakLabel="..."
                        nextLabel="next >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="< previous"
                        renderOnZeroPageCount={null}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={currentPage}
                    /> : null
                }
            </>

        );
    }
    return (
        <div className="INCSUBPools_ctn">{(routeStatus === '/pools' && poolPath === '/pools') || platformPath === "/platform/plan/pools" ?
            (<div className="INCSUBPools_list_container">
                <div className="INCSUBPools_Search_filters">{
                    routeStatus === '/platforms' ?
                        <div className="INCSUBPools_path">
                            <div className='INCSUBPlan_filter_section_path_btn'><svg onClick={() => {
                                dispatch(setPlatformPathRoot(platformPathRoot.substring(0, platformPathRoot.lastIndexOf('/'))))
                                dispatch(setPlatformPath('/platform/plan'))
                            }} className='back_arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                                <h1>{platformPathRoot}<span className='header_info_indicator'>(Pools)</span></h1>
                            </div>
                        </div> : null}
                    <div className="INCSUBPools_Search_filters_container">
                        <INCSUBSearchbar source={'pools'} placeholder={'Search by platform name, categories name'} param={{ pageNumber: pageNo, func: handlePoolSearch }} />
                        <div className="INCSUBPoolsSelectVacancy" onClick={() => {
                            handleVacancy()
                        }} style={{ background: vacancy ? '#BDBFC5' : null }}>Vacant</div>
                        <INCSUBFilterList list={poolStatusList} value={poolStatus} func={handleStatusChange} type={"Status"} />
                        <INCSUBFilterList list={poolTypeList} value={poolType} func={handleTypeChange} type={"Type"} />
                    </div>
                </div>
                <div className="INCSUBPools_card_hlds">
                    <div className="INCSUBPools_card_hlds_scroller">
                        {shimmer ? shimmerList && shimmerList.map(shimmer => <div className="INCSUBPlatforms_card shimmer">
                            <div class="shimmer-card">
                                <div class="shimmer-content">
                                    <div class="shimmer-title"></div>
                                    <div class="shimmer-subtitle"></div>
                                    <div class="shimmer-info"></div>
                                </div>
                            </div>
                        </div>) :

                            poolList && poolList.poolDetailList.length > 0 ? <div className="INCSUBPoollist_holder"> {renderedPoolsCards}</div> : <div className="INCSUBPools_empty">No Pools Data</div>
                        }


                    </div>

                </div>
                <PaginatedItems />
            </div>) : (((routeStatus === '/pools' && poolPath === '/pools/poolDetails') || (routeStatus === '/platforms' && platformPath === "/platform/plan/pools/poolsDetails")) ?
                <INCSUBPoolDetails /> : null)
        }
        </div>
    )
}

export default INCSUBPools;